import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=392164f5&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=392164f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392164f5",
  null
  
)

export default component.exports